/**
 * Master switch for gap diagnostics. While false, the `gapDiagnostics`
 * localStorage flag, the `?gapDiagnostics=true` URL param, and
 * `setGapDiagnosticsEnabled(true)` are all ignored, so no
 * `[gap-diagnostics]` lines are emitted anywhere (workers receive their
 * flag from this gate via the worker init options). Flip to true to make
 * the opt-in flags work again.
 */
export const GAP_DIAGNOSTICS_MASTER_ENABLE = true;
let enabledOverride;
export function setGapDiagnosticsEnabled(enabled) {
    enabledOverride = enabled;
}
export function isGapDiagnosticsEnabled() {
    if (!GAP_DIAGNOSTICS_MASTER_ENABLE) {
        return false;
    }
    if (enabledOverride !== undefined) {
        return enabledOverride;
    }
    try {
        return (globalThis.localStorage?.getItem('gapDiagnostics') === '1' ||
            new URL(globalThis.location?.href ?? '').searchParams.get('gapDiagnostics') === 'true');
    }
    catch {
        return false;
    }
}
export function logGapDiagnostic(layer, event = {}) {
    if (!isGapDiagnosticsEnabled())
        return;
    const payload = {
        layer,
        timestampMs: performance.now(),
        ...event,
    };
    console.log('[gap-diagnostics]', JSON.stringify(payload));
}
const SUMMARY_INTERVAL_MS = 2000;
const accumulators = new Map();
export function logGapDiagnosticSampled(layer, event = {}, outlierThresholdMs = 30) {
    if (!isGapDiagnosticsEnabled())
        return;
    const now = performance.now();
    const deltaMs = event.deltaMs;
    let acc = accumulators.get(layer);
    if (acc === undefined) {
        acc = {
            count: 0,
            sumDeltaMs: 0,
            maxDeltaMs: 0,
            outlierCount: 0,
            lastReportMs: now,
        };
        accumulators.set(layer, acc);
    }
    acc.count++;
    if (deltaMs !== undefined) {
        if (deltaMs > acc.maxDeltaMs)
            acc.maxDeltaMs = deltaMs;
        acc.sumDeltaMs += deltaMs;
        if (deltaMs > outlierThresholdMs)
            acc.outlierCount++;
    }
    if (deltaMs !== undefined && deltaMs > outlierThresholdMs) {
        const payload = {
            layer,
            timestampMs: now,
            ...event,
        };
        console.log('[gap-diagnostics]', JSON.stringify(payload));
    }
    if (now - acc.lastReportMs >= SUMMARY_INTERVAL_MS) {
        const summary = {
            layer: `${layer}.summary`,
            timestampMs: now,
            detail: {
                count: acc.count,
                meanDeltaMs: acc.count > 0
                    ? +(acc.sumDeltaMs / acc.count).toFixed(2)
                    : 0,
                maxDeltaMs: +acc.maxDeltaMs.toFixed(2),
                outlierCount: acc.outlierCount,
                periodMs: +(now - acc.lastReportMs).toFixed(1),
            },
        };
        console.log('[gap-diagnostics]', JSON.stringify(summary));
        acc.count = 0;
        acc.sumDeltaMs = 0;
        acc.maxDeltaMs = 0;
        acc.outlierCount = 0;
        acc.lastReportMs = now;
    }
}
